import { IxFilterSelect } from './IxFilterSelect.js';

window.customElements.define('ix-filter-select', IxFilterSelect);
